import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const admissionService = {
  getAll,
  createOrUpdate,
  deleteAdmission
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/admissions/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newAdmission) {
  const requestOptions = {
    method: newAdmission.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newAdmission)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/admissions${
    newAdmission.id ? `/${newAdmission.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(admission) {
  let formData = new FormData();

  formData.append('admission[title]', admission.title);
  formData.append('admission[date]', admission.date);
  formData.append('admission[description]', admission.description);
  const document = admission.document;

  if (document) {
    if (document.url) {
      formData.append(`admission[document]`, document.url);
    } else {
      formData.append(`admission[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteAdmission(admissionId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/admissions/${admissionId}`;

  return axios.delete(url, requestOptionsDelete);
}
